export default {
  menu: {
    dashboard: "Dashboard",
    sales: "Sales",
    orders: "Orders",
    shipments: "Shipments",
    invoices: "Invoices",
    transactions: "Transactions",

    catalog: "Catalog",
    products: "Products",
    categories: "Categories",
    woods: "Woods",
    warehouses: "Warehouses",

    settings: "Settings",
    general: "General",
    users: "Users",
  },
  common: {
    add: "Add",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    title: "Title",
    description: "Description",
    faq: "FAQ",
    contact: "Contact Us",
    tos: "Terms of Service",
    policy: "Privacy Policy",
  },
  login: {
    title: "Sign In",
    email: "Email",
    userOrEmail: "Username or Email",
    password: "Password",
    button: "Sign In",
    orsign: "Or sign in with",
    forgot: "Forgot password?",
    forgotPassword: "Forgot Password?",
    noaccount: "Don't have an account?",
    create: "Create one here",
    error: "The email / password combination is invalid",
  },
  register: {
    title: "Create Account",
    username: "Username",
    email: "Email",
    password: "Password",
    button: "Create Account",
    orsign: "Or sign up with",
    agree: "By signing up, you agree to the",
    account: "Already have an account?",
    signin: "Sign In",
  },
  forgotPassword: {
    title: "Forgot Password",
    subtitle: "Enter your email address and we'll send you an OTP to reset your password",
    email: "Email Address",
    button: "Send Reset OTP",
    backToLogin: "Back to Login",
  },
  resetPassword: {
    title: "Reset Password",
    subtitle: "Enter the 6-digit OTP sent to your email and create a new password",
    email: "Email Address",
    otpLabel: "6-digit OTP Code",
    newPassword: "New Password",
    confirmPassword: "Confirm New Password",
    button: "Reset Password",
    backToLogin: "Back to Login",
  },
  myAccount: {
    title: "My Account",
    tabs: {
      profile: "Profile",
      security: "Security",
    },
    profile: {
      title: "Profile Information",
      displayName: "Display Name",
      save: "Save Changes",
    },
    changeEmail: {
      title: "Change Email",
      currentEmail: "Current Email",
      newEmail: "New Email",
      currentPassword: "Current Password",
      save: "Change Email",
    },
    changePassword: {
      title: "Change Password",
      newPassword: "New Password",
      confirmPassword: "Confirm New Password",
      save: "Change Password",
    },
    passwordConfirm: {
      title: "Confirm Password",
      warningTitle: "Security Verification Required",
      warningText: "To protect your account, please enter your current password to confirm this email change.",
      confirmationText: "Are you sure you want to change your email from:",
      emailLabel: "Current Email",
      newEmailLabel: "New Email",
      passwordLabel: "Current Password",
      cancel: "Cancel",
      confirm: "Change Email",
    },
    currentPasswordConfirm: {
      title: "Confirm Current Password",
      warningTitle: "Security Verification Required",
      warningText: "To protect your account, please enter your current password to confirm this password change.",
      confirmationText: "You are about to change your password",
      passwordLabel: "Current Password",
      cancel: "Cancel",
      confirm: "Change Password",
    },
    security: {
      title: "Security Settings",
      comingSoon: "Security settings will be available soon.",
      activeSessions: "Active Sessions",
      logoutAll: "Logout All",
      currentSession: "Current",
      lastActivity: "Last activity",
      expires: "Expires",
      revoke: "Revoke",
      refresh: "Refresh",
      noSessions: "No active sessions found.",
      logoutAllConfirm: {
        title: "Logout All Sessions",
        warningTitle: "This will end all your sessions",
        warningText: "You will be logged out from all devices and need to sign in again.",
        description: "This will revoke {count} other session(s) and log you out from all devices.",
        cancel: "Cancel",
        confirm: "Logout All",
      },
    },
  },
  profile: {
    title: "Edit Profile",
    email: "Email Address",
    displayName: "Display Name",
    save: "Save Changes",
    reset: "Reset",
    editProfile: "Edit Profile",
  },
  dashboard: {
    activity: "Activity",
    weeklySales: "Weekly Sales",
    sales: "Sales",
    recentOrders: "Recent Orders",
    sources: "Traffic Sources",
    lastweek: "vs last week",
    orders: "Orders",
    customers: "Customers",
    tickets: "Support Tickets",
    viewReport: "View Report",
  },
  10: "10",
  25: "25",
  50: "50",
  100: "100",
  // Vuetify components translations
  $vuetify: {
    input: {
      clear: "Clear"
    },
    badge: "Badge",
    close: "Close",
    dataIterator: {
      noResultsText: "No matching records found",
      loadingText: "Loading items...",
    },
    dataTable: {
      itemsPerPageText: "Rows per page:",
      ariaLabel: {
        sortDescending: "Sorted descending.",
        sortAscending: "Sorted ascending.",
        sortNone: "Not sorted.",
        activateNone: "Activate to remove sorting.",
        activateDescending: "Activate to sort descending.",
        activateAscending: "Activate to sort ascending.",
      },
      sortBy: "Sort by",
    },
    dataFooter: {
      itemsPerPageText: "Items per page:",
      itemsPerPageAll: "All",
      nextPage: "Next page",
      prevPage: "Previous page",
      firstPage: "First page",
      lastPage: "Last page",
      pageText: "{0}-{1} of {2}",
    },
    datePicker: {
      itemsSelected: "{0} selected",
      nextMonthAriaLabel: "Next month",
      nextYearAriaLabel: "Next year",
      prevMonthAriaLabel: "Previous month",
      prevYearAriaLabel: "Previous year",
    },
    noDataText: "No data available",
    carousel: {
      prev: "Previous visual",
      next: "Next visual",
      ariaLabel: {
        delimiter: "Carousel slide {0} of {1}",
      },
    },
    calendar: {
      moreEvents: "{0} more",
    },
    fileInput: {
      counter: "{0} files",
      counterSize: "{0} files ({1} in total)",
    },
    timePicker: {
      am: "AM",
      pm: "PM",
    },
    pagination: {
      ariaLabel: {
        wrapper: "Pagination Navigation",
        next: "Next page",
        previous: "Previous page",
        page: "Goto Page {0}",
        currentPage: "Current Page, Page {0}",
      },
    },
  },
};
